export default "__VITE_ASSET__CJhdzKO8__"